'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.createPubnubOnStatus = exports.createPubnubOnPresence = exports.pubnubMessageReceived = exports.getPubnubSessionId = exports.getLiveItemData = exports.getLiveCatalogData = exports.getPubNubPublishKey = exports.getCatalogBidders = exports.UPDATE_ACTIVE_BIDDERS_SFS = exports.UPDATE_ACTIVE_BIDDERS_PUBNUB = exports.NEXT_LOT_OPENED = exports.NEXT_LOT_LOADED = exports.NETWORK_RECONNECTED = exports.NETWORK_DISCONNECTED = exports.MISSIVE = exports.LOT_UNSOLD = exports.LOT_SOLD = exports.LOT_SKIPPED = exports.LOT_REOPENED = exports.LOT_PASSED = exports.LOT_CLOSED = exports.BID_RETRACTED = exports.BID_ACCEPTED = exports.AUCTION_STARTED = exports.AUCTION_ENDED = exports.ASK_CHANGED = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;

var _pubnubService = require('../../services/pubnubService');

var pubnubService = _interopRequireWildcard(_pubnubService);

var _catalog = require('./catalog');

var _browser = require('./browser');

var _cloneDeep = require('lodash/cloneDeep');

var _cloneDeep2 = _interopRequireDefault(_cloneDeep);

var _universalCookie = require('universal-cookie');

var _universalCookie2 = _interopRequireDefault(_universalCookie);

var _reselect = require('reselect');

var _user = require('./user');

var _liveBid = require('./liveBid');

var _catalogRegistration = require('./catalogRegistration');

var _liveCatalogStatus = require('./liveCatalogStatus');

var _biddingInfo = require('./biddingInfo');

var _uuid = require('uuid');

var _uuid2 = _interopRequireDefault(_uuid);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cookie = new _universalCookie2.default();

/* Action Types */
var ASK_CHANGED = exports.ASK_CHANGED = 'ASK_CHANGED';
var AUCTION_ENDED = exports.AUCTION_ENDED = 'AUCTION_ENDED';
var AUCTION_STARTED = exports.AUCTION_STARTED = 'AUCTION_STARTED';
var BID_ACCEPTED = exports.BID_ACCEPTED = 'BID_ACCEPTED';
var BID_RETRACTED = exports.BID_RETRACTED = 'BID_RETRACTED';
var LOT_CLOSED = exports.LOT_CLOSED = 'LOT_CLOSED';
var LOT_PASSED = exports.LOT_PASSED = 'LOT_PASSED';
var LOT_REOPENED = exports.LOT_REOPENED = 'LOT_REOPENED';
var LOT_SKIPPED = exports.LOT_SKIPPED = 'LOT_SKIPPED';
var LOT_SOLD = exports.LOT_SOLD = 'LOT_SOLD';
var LOT_UNSOLD = exports.LOT_UNSOLD = 'LOT_UNSOLD';
var MISSIVE = exports.MISSIVE = 'MISSIVE';
var NETWORK_DISCONNECTED = exports.NETWORK_DISCONNECTED = 'NETWORK_DISCONNECTED';
var NETWORK_RECONNECTED = exports.NETWORK_RECONNECTED = 'NETWORK_RECONNECTED';
var NEXT_LOT_LOADED = exports.NEXT_LOT_LOADED = 'NEXT_LOT_LOADED';
var NEXT_LOT_OPENED = exports.NEXT_LOT_OPENED = 'NEXT_LOT_OPENED';
var UPDATE_ACTIVE_BIDDERS_PUBNUB = exports.UPDATE_ACTIVE_BIDDERS_PUBNUB = 'UPDATE_ACTIVE_BIDDERS_PUBNUB';
var UPDATE_ACTIVE_BIDDERS_SFS = exports.UPDATE_ACTIVE_BIDDERS_SFS = 'UPDATE_ACTIVE_BIDDERS_SFS';

/* helpers */
var getCurrentTimestamp = function getCurrentTimestamp() {
    return new Date().getTime();
};

/* reducer */
var DEFAULT_STATE = {
    catalogs: {},
    items: {}
};

var DEFAULT_CATALOG = {
    activeBidder: false,
    approved: false,
    bidderOutbid: false,
    bidders: 1,
    closed: true,
    currentItem: 0,
    networkStatus: 'connected',
    pubNubPublishKey: '',
    status: '',
    won: false
};

var setCatalogLive = function setCatalogLive(state, catalogId) {
    var catalogs = (0, _cloneDeep2.default)(state.catalogs);
    catalogs[catalogId] = catalogs[catalogId] || (0, _cloneDeep2.default)(DEFAULT_CATALOG);
    catalogs[catalogId].status = 'live';
    return catalogs;
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var catalogs = void 0;
    var current = void 0;
    var currentCreatedTimeStamp = void 0;
    var itemId = void 0;
    var items = void 0;

    switch (action.type) {
        case ASK_CHANGED:
            catalogs = setCatalogLive(state, action.payload.catalogId);
            catalogs[action.payload.catalogId].currentItem = action.payload.itemId;
            catalogs[action.payload.catalogId].currentItemIndex = action.payload.itemIndex;
            items = (0, _cloneDeep2.default)(state.items);
            items[action.payload.itemId] = items[action.payload.itemId] || {};
            items[action.payload.itemId].currentAskPrice = action.payload.ask;

            return (0, _extends3.default)({}, state, {
                catalogs: catalogs,
                items: items
            });
        case AUCTION_ENDED:
            catalogs = (0, _cloneDeep2.default)(state.catalogs);
            catalogs[action.payload.catalogId] = catalogs[action.payload.catalogId] || {};
            catalogs[action.payload.catalogId].status = 'done';

            return (0, _extends3.default)({}, state, {
                catalogs: catalogs
            });
        case AUCTION_STARTED:
            catalogs = setCatalogLive(state, action.payload.catalogId);

            return (0, _extends3.default)({}, state, {
                catalogs: catalogs
            });
        case BID_ACCEPTED:
            catalogs = setCatalogLive(state, action.payload.catalogId);
            catalogs[action.payload.catalogId].currentItem = action.payload.itemId;
            catalogs[action.payload.catalogId].currentItemIndex = action.payload.itemIndex;
            catalogs[action.payload.catalogId].closed = false;
            catalogs[action.payload.catalogId].activeBidder = !!catalogs[action.payload.catalogId].activeBidder || !!action.payload.myBid;
            catalogs[action.payload.catalogId].bidderOutbid = !!action.payload.bidderOutbid;

            items = (0, _cloneDeep2.default)(state.items);
            items[action.payload.itemId] = items[action.payload.itemId] || { created: getCurrentTimestamp() };
            current = items[action.payload.itemId];
            currentCreatedTimeStamp = current.created;
            if (currentCreatedTimeStamp < action.payload.created) {
                current.previousBidAmount = action.payload.previousBidAmount;
                current.created = action.payload.created;
                current.leadingBid = action.payload.amount;
                current.leadingBidder = action.payload.bidderId;
                current.currentAskPrice = action.payload.ask;
                current.source = action.payload.source;
            }

            return (0, _extends3.default)({}, state, {
                catalogs: catalogs,
                items: items
            });

        case BID_RETRACTED:
            catalogs = setCatalogLive(state, action.payload.catalogId);
            catalogs[action.payload.catalogId].currentItem = action.payload.itemId;
            catalogs[action.payload.catalogId].currentItemIndex = action.payload.itemIndex;
            catalogs[action.payload.catalogId].bidderOutbid = false;
            catalogs[action.payload.catalogId].closed = false;

            items = (0, _cloneDeep2.default)(state.items);
            items[action.payload.itemId] = items[action.payload.itemId] || {};
            items[action.payload.itemId].leadingBid = action.payload.amount;
            items[action.payload.itemId].leadingBidder = action.payload.bidderId;
            items[action.payload.itemId].currentAskPrice = action.payload.ask;
            items[action.payload.itemId].source = action.payload.source;
            items[action.payload.itemId].created = action.payload.created;

            return (0, _extends3.default)({}, state, {
                catalogs: catalogs,
                items: items
            });
        case LOT_CLOSED:
            catalogs = setCatalogLive(state, action.payload.catalogId);
            catalogs[action.payload.catalogId].bidderOutbid = false;
            if (catalogs[action.payload.catalogId].currentItem === action.payload.itemId) {
                catalogs[action.payload.catalogId].closed = true;
            }

            return (0, _extends3.default)({}, state, {
                catalogs: catalogs
            });
        case LOT_PASSED:
            catalogs = setCatalogLive(state, action.payload.catalogId);
            catalogs[action.payload.catalogId].closed = true;
            catalogs[action.payload.catalogId].bidderOutbid = false;

            return (0, _extends3.default)({}, state, {
                catalogs: catalogs
            });
        case LOT_REOPENED:
            catalogs = setCatalogLive(state, action.payload.catalogId);
            catalogs[action.payload.catalogId].closed = false;

            return (0, _extends3.default)({}, state, {
                catalogs: catalogs
            });
        case LOT_SOLD:
            catalogs = setCatalogLive(state, action.payload.catalogId);
            catalogs[action.payload.catalogId].closed = true;
            catalogs[action.payload.catalogId].bidderOutbid = false;
            catalogs[action.payload.catalogId].won = action.payload.myBid;

            return (0, _extends3.default)({}, state, {
                catalogs: catalogs
            });
        case LOT_UNSOLD:
            catalogs = setCatalogLive(state, action.payload.catalogId);
            catalogs[action.payload.catalogId].bidderOutbid = false;
            catalogs[action.payload.catalogId].closed = true;
            return (0, _extends3.default)({}, state, {
                catalogs: catalogs
            });
        case MISSIVE:
            catalogs = setCatalogLive(state, action.payload.catalogId);

            return (0, _extends3.default)({}, state, {
                catalogs: catalogs
            });
        case NEXT_LOT_OPENED:
            // This does not do what one might think
            break;
        case NETWORK_DISCONNECTED:
            catalogs = (0, _cloneDeep2.default)(state.catalogs);
            catalogs[action.payload.catalogId] = catalogs[action.payload.catalogId] || {};
            catalogs[action.payload.catalogId].networkStatus = 'disconnected';
            return (0, _extends3.default)({}, state, {
                catalogs: catalogs
            });
        case NETWORK_RECONNECTED:
            catalogs = (0, _cloneDeep2.default)(state.catalogs);
            catalogs[action.payload.catalogId] = catalogs[action.payload.catalogId] || {};
            catalogs[action.payload.catalogId].networkStatus = 'connected';
            return (0, _extends3.default)({}, state, {
                catalogs: catalogs
            });
        case _catalogRegistration.LOAD_CATALOG_REGISTRATION_SUCCESS:
            if (state.catalogs[action.payload.catalogId].pubNubPublishKey !== action.payload.publishKey || state.catalogs[action.payload.catalogId].approved !== action.payload.approved) {
                catalogs = (0, _cloneDeep2.default)(state.catalogs);
                catalogs[action.meta.catalogId].pubNubPublishKey = action.payload.publishKey;
                catalogs[action.meta.catalogId].approved = action.payload.approved;
                return (0, _extends3.default)({}, state, {
                    catalogs: catalogs
                });
            }

            return (0, _extends3.default)({}, state);
        case _liveCatalogStatus.LOAD_LIVE_CATALOG_STATUS_SUCCESS:
            catalogs = (0, _cloneDeep2.default)(state.catalogs);
            catalogs[action.payload.catalogId] = catalogs[action.payload.catalogId] || {};
            catalogs[action.payload.catalogId].currency = action.payload.currency;
            catalogs[action.payload.catalogId].status = action.payload.status;
            catalogs[action.payload.catalogId].itemCount = action.payload.itemCount;

            items = (0, _cloneDeep2.default)(state.items);

            if (action.payload.currentItem && action.payload.currentItem.itemId) {
                var _action$payload$curre = action.payload.currentItem,
                    askPrice = _action$payload$curre.askPrice,
                    created = _action$payload$curre.created,
                    highEstimate = _action$payload$curre.highEstimate,
                    _itemId = _action$payload$curre.itemId,
                    itemIndex = _action$payload$curre.itemIndex,
                    leadingBid = _action$payload$curre.leadingBid,
                    leadingBidder = _action$payload$curre.leadingBidder,
                    lotDescription = _action$payload$curre.lotDescription,
                    lotNumber = _action$payload$curre.lotNumber,
                    lotTitle = _action$payload$curre.lotTitle,
                    lowEstimate = _action$payload$curre.lowEstimate;


                catalogs[action.payload.catalogId].closed = false;
                catalogs[action.payload.catalogId].won = false;
                catalogs[action.payload.catalogId].currentItem = _itemId;
                catalogs[action.payload.catalogId].currentItemIndex = itemIndex;
                items[_itemId] = items[_itemId] || {};
                items[_itemId].created = created || getCurrentTimestamp();
                items[_itemId].currentAskPrice = askPrice;
                items[_itemId].description = lotDescription;
                items[_itemId].highEstimate = highEstimate;
                items[_itemId].leadingBid = leadingBid || 0;
                items[_itemId].leadingBidder = leadingBidder || 0;
                items[_itemId].lotNumber = lotNumber;
                items[_itemId].lowEstimate = lowEstimate;
                items[_itemId].title = lotTitle;
            }

            return (0, _extends3.default)({}, state, {
                catalogs: catalogs,
                items: items
            });
        case NEXT_LOT_LOADED:
            itemId = action.payload.itemId;

            catalogs = setCatalogLive(state, action.payload.catalogId);
            catalogs[action.payload.catalogId].currentItem = itemId;
            catalogs[action.payload.catalogId].currentItemIndex = action.payload.itemIndex;
            catalogs[action.payload.catalogId].currency = action.payload.currency;
            catalogs[action.payload.catalogId].closed = false;
            catalogs[action.payload.catalogId].won = false;
            catalogs[action.payload.catalogId].activeBidder = false;
            catalogs[action.payload.catalogId].bidderOutbid = false;

            items = (0, _cloneDeep2.default)(state.items);
            items[itemId] = items[itemId] || {};
            items[itemId].leadingBid = 0;
            items[itemId].leadingBidder = 0;
            items[itemId].currentAskPrice = action.payload.askPrice;
            items[itemId].lotNumber = action.payload.lotNumber;
            items[itemId].title = action.payload.lotTitle;
            items[itemId].description = action.payload.description;
            items[itemId].highEstimate = action.payload.highEstimate;
            items[itemId].lowEstimate = action.payload.lowEstimate;
            items[itemId].index = action.payload.index;
            items[itemId].status = action.payload.status;
            items[itemId].created = action.payload.created;

            return (0, _extends3.default)({}, state, {
                catalogs: catalogs,
                items: items
            });
        case UPDATE_ACTIVE_BIDDERS_PUBNUB:
            catalogs = (0, _cloneDeep2.default)(state.catalogs);
            catalogs[action.payload.catalogId] = catalogs[action.payload.catalogId] || {};
            catalogs[action.payload.catalogId].pubnubBidderCount = action.payload.bidderCount;

            return (0, _extends3.default)({}, state, {
                catalogs: catalogs
            });
        case UPDATE_ACTIVE_BIDDERS_SFS:
            catalogs = (0, _cloneDeep2.default)(state.catalogs);
            catalogs[action.payload.catalogId].currentItem = action.payload.itemId;
            catalogs[action.payload.catalogId].currentItemIndex = action.payload.itemIndex;

            catalogs[action.payload.catalogId] = catalogs[action.payload.catalogId] || {};
            catalogs[action.payload.catalogId].sfsBidderCount = action.payload.bidderCount;

            return (0, _extends3.default)({}, state, {
                catalogs: catalogs
            });
        case _catalog.LOAD_CATALOGS_SUCCESS:
            catalogs = (0, _cloneDeep2.default)(state.catalogs);
            action.payload.catalogs.forEach(function (catalog) {
                if (catalog.catalogStatus === 'done') {
                    // set the catalog to done if it is
                    catalogs[catalog.catalogId] = catalogs[catalog.catalogId] || {};
                    catalogs[catalog.catalogId].status = catalog.catalogStatus;
                }
            });

            return (0, _extends3.default)({}, state, {
                catalogs: catalogs
            });
        default:
            return state;
    }
}

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.console;
};
var idSelector = function idSelector(state, id) {
    return id;
};

var catalogsSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.catalogs;
});
var itemsSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.items;
});

var getCatalogBidders = exports.getCatalogBidders = (0, _reselect.createSelector)([catalogsSelector, idSelector], function (catalogs, id) {
    var catalog = catalogs[id] || {};
    var sfs = catalog.sfsBidderCount || 0;
    var pubnub = catalog.pubnubBidderCount || 0;
    return sfs + pubnub || 1;
});

var getPubNubPublishKey = exports.getPubNubPublishKey = (0, _reselect.createSelector)([catalogsSelector, idSelector], function (catalogs, id) {
    var catalog = catalogs[id] || {};
    return catalog.pubNubPublishKey || '';
});

var getLiveCatalogData = exports.getLiveCatalogData = (0, _reselect.createSelector)([catalogsSelector, getCatalogBidders, idSelector], function (catalogs, bidders, id) {
    return (0, _extends3.default)({}, DEFAULT_CATALOG, catalogs[id] || {}, { bidders: bidders });
});

var getLiveItemData = exports.getLiveItemData = (0, _reselect.createSelector)([itemsSelector, idSelector], function (items, id) {
    return items[id] || { leadingBid: 0, leadingBidder: 0 };
});

var getPubnubSessionId = exports.getPubnubSessionId = function getPubnubSessionId(state) {
    var mobileBrowser = (0, _browser.getMobileBrowserOS)(state);
    var tablet = (0, _browser.isUiTablet)(state);

    var _getUiBrowser = (0, _browser.getUiBrowser)(state),
        majorVersion = _getUiBrowser.majorVersion,
        name = _getUiBrowser.name;

    var browser = '' + name + majorVersion;

    var deviceType = !mobileBrowser ? 'computer' : tablet ? 'tablet' : 'phone';
    var sessionId = (cookie.get('_session_id') || _uuid2.default.v4()) + '::web-' + deviceType + '-' + browser;
    return sessionId;
};

/* ACTION CREATORS */
var pubnubMessageReceived = exports.pubnubMessageReceived = function pubnubMessageReceived(message) {
    return function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch, getState) {
            var eventJson, event, created, _event, catalogId, EventType, state, currentBidderId, catalog, currency, _event2, AskPrice, AuctionId, LotId, LotNumber, _event3, _AuctionId, _event4, _AuctionId2, _event5, Amount, _AskPrice, AssignedId, _AuctionId3, BidSource, BidderId, _LotId, LotIndex, _LotNumber, _event6, _Amount, _AskPrice2, _AuctionId4, _BidSource, _BidderId, _LotId2, _LotIndex, _LotNumber2, _event7, _AuctionId5, _LotId3, _LotNumber3, _event8, _AuctionId6, NextLot, _event9, _AuctionId7, _LotId4, _LotNumber4, _event10, _AuctionId8, _LotId5, _LotNumber5, _event11, _AuctionId9, _LotNumber6, _event12, _Amount2, _AssignedId, _AuctionId10, _BidderId2, _LotId6, _LotNumber7, _event13, _AuctionId11, _LotNumber8, _event14, _AuctionId12, MissiveText, _event15, _AuctionId13, _LotId7, _LotNumber9, _event16, _AuctionId14, _LotId8, _LotIndex2, UserCount;

            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            eventJson = message.message;
                            event = void 0;

                            try {
                                event = JSON.parse(eventJson);
                            } catch (err) {
                                event = {};
                            }
                            created = new Date().getTime();
                            _event = event, catalogId = _event.AuctionId, EventType = _event.EventType;
                            state = getState();
                            currentBidderId = (0, _user.getBidderId)(state);
                            catalog = (0, _catalog.getCatalog)(state, catalogId);
                            currency = catalog.currency;

                            if (!(EventType === 'ask-changed')) {
                                _context.next = 14;
                                break;
                            }

                            _event2 = event, AskPrice = _event2.AskPrice, AuctionId = _event2.AuctionId, LotId = _event2.LotId, LotNumber = _event2.LotNumber;
                            return _context.abrupt('return', dispatch(askChanged({
                                ask: AskPrice,
                                catalogId: AuctionId,
                                created: created,
                                currency: currency,
                                itemId: LotId,
                                lotNumber: LotNumber
                            })));

                        case 14:
                            if (!(EventType === 'auction-started')) {
                                _context.next = 19;
                                break;
                            }

                            _event3 = event, _AuctionId = _event3.AuctionId;
                            return _context.abrupt('return', dispatch(auctionStarted({ catalogId: _AuctionId, created: created })));

                        case 19:
                            if (!(EventType === 'auction-closed')) {
                                _context.next = 24;
                                break;
                            }

                            _event4 = event, _AuctionId2 = _event4.AuctionId;
                            return _context.abrupt('return', dispatch(auctionClosed({ catalogId: _AuctionId2, created: created })));

                        case 24:
                            if (!(EventType === 'bid-accepted')) {
                                _context.next = 29;
                                break;
                            }

                            _event5 = event, Amount = _event5.Amount, _AskPrice = _event5.AskPrice, AssignedId = _event5.AssignedId, _AuctionId3 = _event5.AuctionId, BidSource = _event5.BidSource, BidderId = _event5.BidderId, _LotId = _event5.LotId, LotIndex = _event5.LotIndex, _LotNumber = _event5.LotNumber;
                            return _context.abrupt('return', dispatch(bidAccepted({
                                amount: Amount,
                                ask: _AskPrice,
                                bidderId: BidderId,
                                catalogId: _AuctionId3,
                                created: created,
                                currency: currency,
                                itemId: _LotId,
                                itemIndex: LotIndex,
                                lotNumber: _LotNumber,
                                myBid: BidderId === currentBidderId && BidderId !== -1,
                                paddleNumber: AssignedId,
                                source: BidSource
                            })));

                        case 29:
                            if (!(EventType === 'bid-retracted')) {
                                _context.next = 34;
                                break;
                            }

                            _event6 = event, _Amount = _event6.Amount, _AskPrice2 = _event6.AskPrice, _AuctionId4 = _event6.AuctionId, _BidSource = _event6.BidSource, _BidderId = _event6.BidderId, _LotId2 = _event6.LotId, _LotIndex = _event6.LotIndex, _LotNumber2 = _event6.LotNumber;
                            return _context.abrupt('return', dispatch(bidRetracted({
                                amount: _Amount,
                                ask: _AskPrice2,
                                bidderId: _BidderId,
                                catalogId: _AuctionId4,
                                created: created,
                                currency: currency,
                                itemId: _LotId2,
                                itemIndex: _LotIndex,
                                lotNumber: _LotNumber2,
                                source: _BidSource
                            })));

                        case 34:
                            if (!(EventType === 'lot-closed')) {
                                _context.next = 39;
                                break;
                            }

                            _event7 = event, _AuctionId5 = _event7.AuctionId, _LotId3 = _event7.LotId, _LotNumber3 = _event7.LotNumber;
                            return _context.abrupt('return', dispatch(lotClosed({ catalogId: _AuctionId5, created: created, itemId: _LotId3, lotNumber: _LotNumber3 })));

                        case 39:
                            if (!(EventType === 'lot-loaded')) {
                                _context.next = 44;
                                break;
                            }

                            _event8 = event, _AuctionId6 = _event8.AuctionId, NextLot = _event8.NextLot;
                            return _context.abrupt('return', dispatch(nextLotLoaded({
                                askPrice: NextLot.AskPrice,
                                catalogId: _AuctionId6,
                                created: created,
                                currency: currency,
                                description: NextLot.LotDescription,
                                highEstimate: NextLot.HighEstimate,
                                index: NextLot.Index,
                                itemId: NextLot.LotId,
                                itemIndex: NextLot.Index,
                                lotNumber: NextLot.LotNumber,
                                lotTitle: NextLot.LotTitle,
                                lowEstimate: NextLot.LowEstimate,
                                status: NextLot.Status
                            })));

                        case 44:
                            if (!(EventType === 'lot-passed')) {
                                _context.next = 49;
                                break;
                            }

                            _event9 = event, _AuctionId7 = _event9.AuctionId, _LotId4 = _event9.LotId, _LotNumber4 = _event9.LotNumber;
                            return _context.abrupt('return', dispatch(lotPassed({ catalogId: _AuctionId7, created: created, itemId: _LotId4, lotNumber: _LotNumber4 })));

                        case 49:
                            if (!(EventType === 'lot-reopened')) {
                                _context.next = 54;
                                break;
                            }

                            _event10 = event, _AuctionId8 = _event10.AuctionId, _LotId5 = _event10.LotId, _LotNumber5 = _event10.LotNumber;
                            return _context.abrupt('return', dispatch(lotReopened({ catalogId: _AuctionId8, created: created, itemId: _LotId5, lotNumber: _LotNumber5 })));

                        case 54:
                            if (!(EventType === 'lot-skipped')) {
                                _context.next = 59;
                                break;
                            }

                            _event11 = event, _AuctionId9 = _event11.AuctionId, _LotNumber6 = _event11.LotNumber;
                            return _context.abrupt('return', dispatch(lotSkipped({ catalogId: _AuctionId9, created: created, lotNumber: _LotNumber6 })));

                        case 59:
                            if (!(EventType === 'lot-sold')) {
                                _context.next = 64;
                                break;
                            }

                            _event12 = event, _Amount2 = _event12.Amount, _AssignedId = _event12.AssignedId, _AuctionId10 = _event12.AuctionId, _BidderId2 = _event12.BidderId, _LotId6 = _event12.LotId, _LotNumber7 = _event12.LotNumber;
                            return _context.abrupt('return', dispatch(lotSold({
                                amount: _Amount2,
                                bidderId: _BidderId2,
                                catalogId: _AuctionId10,
                                created: created,
                                currency: currency,
                                itemId: _LotId6,
                                lotNumber: _LotNumber7,
                                myBid: _BidderId2 === currentBidderId && _BidderId2 !== -1,
                                paddleNumber: _AssignedId
                            })));

                        case 64:
                            if (!(EventType === 'lot-unsold')) {
                                _context.next = 69;
                                break;
                            }

                            _event13 = event, _AuctionId11 = _event13.AuctionId, _LotNumber8 = _event13.LotNumber;
                            return _context.abrupt('return', dispatch(lotUnsold({ catalogId: _AuctionId11, created: created, lotNumber: _LotNumber8 })));

                        case 69:
                            if (!(EventType === 'missive-sent')) {
                                _context.next = 74;
                                break;
                            }

                            _event14 = event, _AuctionId12 = _event14.AuctionId, MissiveText = _event14.MissiveText;
                            return _context.abrupt('return', dispatch(missive({ catalogId: _AuctionId12, created: created, missiveText: MissiveText })));

                        case 74:
                            if (!(EventType === 'next-lot-opened')) {
                                _context.next = 79;
                                break;
                            }

                            _event15 = event, _AuctionId13 = _event15.AuctionId, _LotId7 = _event15.LotId, _LotNumber9 = _event15.LotNumber;
                            return _context.abrupt('return', dispatch(nextLotOpened({
                                catalogId: _AuctionId13,
                                created: created,
                                currency: currency,
                                itemId: _LotId7,
                                lotNumber: _LotNumber9
                            })));

                        case 79:
                            if (!(EventType === 'user-count-updated')) {
                                _context.next = 82;
                                break;
                            }

                            _event16 = event, _AuctionId14 = _event16.AuctionId, _LotId8 = _event16.LotId, _LotIndex2 = _event16.LotIndex, UserCount = _event16.UserCount;
                            return _context.abrupt('return', dispatch(updateActiveBiddersSfs({
                                bidderCount: UserCount,
                                catalogId: _AuctionId14,
                                created: created,
                                itemId: _LotId8,
                                itemIndex: _LotIndex2
                            })));

                        case 82:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, undefined);
        }));

        return function (_x3, _x4) {
            return _ref.apply(this, arguments);
        };
    }();
};

var createPubnubOnPresence = exports.createPubnubOnPresence = function createPubnubOnPresence(catalogId) {
    return function (presenceEvent) {
        return function () {
            var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(dispatch) {
                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                if (!(presenceEvent.action === 'join')) {
                                    _context2.next = 4;
                                    break;
                                }

                                return _context2.abrupt('return', dispatch(updateActiveBiddersPubnub({
                                    bidderCount: presenceEvent.occupancy,
                                    catalogId: catalogId
                                })));

                            case 4:
                                if (!(presenceEvent.action === 'leave')) {
                                    _context2.next = 8;
                                    break;
                                }

                                return _context2.abrupt('return', dispatch(updateActiveBiddersPubnub({
                                    bidderCount: presenceEvent.occupancy,
                                    catalogId: catalogId
                                })));

                            case 8:
                                if (!(presenceEvent.action === 'timeout')) {
                                    _context2.next = 12;
                                    break;
                                }

                                return _context2.abrupt('return', dispatch(updateActiveBiddersPubnub({
                                    bidderCount: presenceEvent.occupancy,
                                    catalogId: catalogId
                                })));

                            case 12:
                                if (!(presenceEvent.action === 'interval')) {
                                    _context2.next = 14;
                                    break;
                                }

                                return _context2.abrupt('return', dispatch(updateActiveBiddersPubnub({
                                    bidderCount: presenceEvent.occupancy,
                                    catalogId: catalogId
                                })));

                            case 14:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, undefined);
            }));

            return function (_x5) {
                return _ref2.apply(this, arguments);
            };
        }();
    };
};

var createPubnubOnStatus = exports.createPubnubOnStatus = function createPubnubOnStatus(catalogId, channel) {
    return function (statusEvent) {
        return function () {
            var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(dispatch) {
                var response;
                return _regenerator2.default.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                if (!(statusEvent.category === 'PNNetworkUpCategory')) {
                                    _context3.next = 4;
                                    break;
                                }

                                return _context3.abrupt('return', dispatch(networkReconnected({ catalogId: catalogId })));

                            case 4:
                                if (!(statusEvent.category === 'PNNetworkDownCategory')) {
                                    _context3.next = 8;
                                    break;
                                }

                                return _context3.abrupt('return', dispatch(networkDisconnected({ catalogId: catalogId })));

                            case 8:
                                if (!(statusEvent.category === 'PNNetworkIssuesCategory')) {
                                    _context3.next = 12;
                                    break;
                                }

                                return _context3.abrupt('return', dispatch(networkDisconnected({ catalogId: catalogId })));

                            case 12:
                                if (!(statusEvent.category === 'PNReconnectedCategory')) {
                                    _context3.next = 16;
                                    break;
                                }

                                return _context3.abrupt('return', dispatch(networkReconnected({ catalogId: catalogId })));

                            case 16:
                                if (!(statusEvent.category === 'PNConnectedCategory')) {
                                    _context3.next = 24;
                                    break;
                                }

                                dispatch(networkReconnected({ catalogId: catalogId }));
                                // request the here now data
                                _context3.next = 20;
                                return pubnubService.hereNow(channel);

                            case 20:
                                response = _context3.sent;
                                return _context3.abrupt('return', dispatch(updateActiveBiddersPubnub({
                                    bidderCount: response.channels[channel].occupancy,
                                    catalogId: catalogId
                                })));

                            case 24:
                                if (statusEvent.category === 'PNAccessDeniedCategory') {
                                    /* eslint-disable-next-line */
                                } else if (statusEvent.category === 'PNMalformedResponseCategory') {
                                    /* eslint-disable-next-line */
                                } else if (statusEvent.category === 'PNBadRequestCategory') {
                                    /* eslint-disable-next-line */
                                } else if (statusEvent.category === 'PNDecryptionErrorCategory') {
                                    /* eslint-disable-next-line */
                                } else if (statusEvent.category === 'PNUnknownCategory') {
                                    /* eslint-disable-next-line */
                                } else if (statusEvent.category === 'PNTimeoutCategory') {}

                            case 25:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, undefined);
            }));

            return function (_x6) {
                return _ref3.apply(this, arguments);
            };
        }();
    };
};

var askChanged = function askChanged(_ref4) {
    var ask = _ref4.ask,
        catalogId = _ref4.catalogId,
        created = _ref4.created,
        currency = _ref4.currency,
        itemId = _ref4.itemId,
        lotNumber = _ref4.lotNumber;
    return {
        payload: { ask: ask, catalogId: catalogId, created: created, currency: currency, itemId: itemId, lotNumber: lotNumber },
        type: ASK_CHANGED
    };
};

var auctionClosed = function auctionClosed(_ref5) {
    var catalogId = _ref5.catalogId,
        created = _ref5.created;
    return {
        payload: { catalogId: catalogId, created: created },
        type: AUCTION_ENDED
    };
};

var auctionStarted = function auctionStarted(_ref6) {
    var catalogId = _ref6.catalogId,
        created = _ref6.created;
    return {
        payload: { catalogId: catalogId, created: created },
        type: AUCTION_STARTED
    };
};

var bidAccepted = function bidAccepted(_ref7) {
    var amount = _ref7.amount,
        ask = _ref7.ask,
        bidderId = _ref7.bidderId,
        catalogId = _ref7.catalogId,
        created = _ref7.created,
        currency = _ref7.currency,
        itemId = _ref7.itemId,
        itemIndex = _ref7.itemIndex,
        lotNumber = _ref7.lotNumber,
        myBid = _ref7.myBid,
        paddleNumber = _ref7.paddleNumber,
        source = _ref7.source;
    return function () {
        var _ref8 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4(dispatch, getState) {
            var state, currentBidderId, _getUiLiveBid, bidderHasHighBid, submitted, bidderOutbid, previousBidAmount;

            return _regenerator2.default.wrap(function _callee4$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            state = getState();
                            currentBidderId = (0, _user.getBidderId)(state);
                            _getUiLiveBid = (0, _liveBid.getUiLiveBid)(state), bidderHasHighBid = _getUiLiveBid.bidderHasHighBid, submitted = _getUiLiveBid.submitted;
                            bidderOutbid = currentBidderId !== bidderId && bidderHasHighBid && bidderId !== -1 || submitted && !myBid;
                            previousBidAmount = getLiveItemData(state, itemId).leadingBid;
                            return _context4.abrupt('return', dispatch({
                                payload: {
                                    amount: amount,
                                    ask: ask,
                                    bidderId: bidderId,
                                    bidderOutbid: bidderOutbid,
                                    catalogId: catalogId,
                                    created: created,
                                    currency: currency,
                                    itemId: itemId,
                                    itemIndex: itemIndex,
                                    lotNumber: lotNumber,
                                    myBid: myBid,
                                    paddleNumber: paddleNumber,
                                    previousBidAmount: previousBidAmount,
                                    source: source
                                },
                                type: BID_ACCEPTED
                            }));

                        case 6:
                        case 'end':
                            return _context4.stop();
                    }
                }
            }, _callee4, undefined);
        }));

        return function (_x7, _x8) {
            return _ref8.apply(this, arguments);
        };
    }();
};

var bidRetracted = function bidRetracted(_ref9) {
    var amount = _ref9.amount,
        ask = _ref9.ask,
        bidderId = _ref9.bidderId,
        catalogId = _ref9.catalogId,
        created = _ref9.created,
        currency = _ref9.currency,
        itemId = _ref9.itemId,
        itemIndex = _ref9.itemIndex,
        lotNumber = _ref9.lotNumber,
        source = _ref9.source;
    return function () {
        var _ref10 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee5(dispatch, getState) {
            var state, currentBidderId, itemData, myBid;
            return _regenerator2.default.wrap(function _callee5$(_context5) {
                while (1) {
                    switch (_context5.prev = _context5.next) {
                        case 0:
                            state = getState();
                            currentBidderId = (0, _user.getBidderId)(state);
                            itemData = getLiveItemData(state, itemId);
                            myBid = itemData.leadingBidder === currentBidderId;
                            return _context5.abrupt('return', dispatch({
                                payload: {
                                    amount: amount,
                                    ask: ask,
                                    bidderId: bidderId,
                                    catalogId: catalogId,
                                    created: created,
                                    currency: currency,
                                    currentBidderId: currentBidderId,
                                    itemId: itemId,
                                    itemIndex: itemIndex,
                                    lotNumber: lotNumber,
                                    myBid: myBid,
                                    source: source
                                },
                                type: BID_RETRACTED
                            }));

                        case 5:
                        case 'end':
                            return _context5.stop();
                    }
                }
            }, _callee5, undefined);
        }));

        return function (_x9, _x10) {
            return _ref10.apply(this, arguments);
        };
    }();
};

var lotSold = function lotSold(_ref11) {
    var amount = _ref11.amount,
        bidderId = _ref11.bidderId,
        catalogId = _ref11.catalogId,
        created = _ref11.created,
        currency = _ref11.currency,
        itemId = _ref11.itemId,
        lotNumber = _ref11.lotNumber,
        myBid = _ref11.myBid,
        paddleNumber = _ref11.paddleNumber;
    return function () {
        var _ref12 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee6(dispatch) {
            return _regenerator2.default.wrap(function _callee6$(_context6) {
                while (1) {
                    switch (_context6.prev = _context6.next) {
                        case 0:
                            dispatch({
                                payload: {
                                    itemId: itemId,
                                    salePrice: amount,
                                    status: 'sold'
                                },
                                type: _biddingInfo.UPDATE_ITEM_STATUS
                            });
                            return _context6.abrupt('return', dispatch({
                                payload: { amount: amount, bidderId: bidderId, catalogId: catalogId, created: created, currency: currency, lotNumber: lotNumber, myBid: myBid, paddleNumber: paddleNumber },
                                type: LOT_SOLD
                            }));

                        case 2:
                        case 'end':
                            return _context6.stop();
                    }
                }
            }, _callee6, undefined);
        }));

        return function (_x11) {
            return _ref12.apply(this, arguments);
        };
    }();
};

var lotUnsold = function lotUnsold(_ref13) {
    var catalogId = _ref13.catalogId,
        created = _ref13.created,
        lotNumber = _ref13.lotNumber;
    return {
        payload: { catalogId: catalogId, created: created, lotNumber: lotNumber },
        type: LOT_UNSOLD
    };
};

var lotClosed = function lotClosed(_ref14) {
    var catalogId = _ref14.catalogId,
        created = _ref14.created,
        itemId = _ref14.itemId,
        lotNumber = _ref14.lotNumber;
    return {
        payload: { catalogId: catalogId, created: created, itemId: itemId, lotNumber: lotNumber },
        type: LOT_CLOSED
    };
};

var lotPassed = function lotPassed(_ref15) {
    var catalogId = _ref15.catalogId,
        created = _ref15.created,
        itemId = _ref15.itemId,
        lotNumber = _ref15.lotNumber;
    return function () {
        var _ref16 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee7(dispatch) {
            return _regenerator2.default.wrap(function _callee7$(_context7) {
                while (1) {
                    switch (_context7.prev = _context7.next) {
                        case 0:
                            dispatch({
                                payload: {
                                    itemId: itemId,
                                    status: 'passed'
                                },
                                type: _biddingInfo.UPDATE_ITEM_STATUS
                            });
                            return _context7.abrupt('return', dispatch({
                                payload: { catalogId: catalogId, created: created, lotNumber: lotNumber },
                                type: LOT_PASSED
                            }));

                        case 2:
                        case 'end':
                            return _context7.stop();
                    }
                }
            }, _callee7, undefined);
        }));

        return function (_x12) {
            return _ref16.apply(this, arguments);
        };
    }();
};

var lotReopened = function lotReopened(_ref17) {
    var catalogId = _ref17.catalogId,
        created = _ref17.created,
        itemId = _ref17.itemId,
        lotNumber = _ref17.lotNumber;
    return function () {
        var _ref18 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee8(dispatch) {
            return _regenerator2.default.wrap(function _callee8$(_context8) {
                while (1) {
                    switch (_context8.prev = _context8.next) {
                        case 0:
                            dispatch({
                                payload: {
                                    itemId: itemId,
                                    status: 'available'
                                },
                                type: _biddingInfo.UPDATE_ITEM_STATUS
                            });
                            return _context8.abrupt('return', dispatch({
                                payload: { catalogId: catalogId, created: created, lotNumber: lotNumber },
                                type: LOT_REOPENED
                            }));

                        case 2:
                        case 'end':
                            return _context8.stop();
                    }
                }
            }, _callee8, undefined);
        }));

        return function (_x13) {
            return _ref18.apply(this, arguments);
        };
    }();
};

var lotSkipped = function lotSkipped(_ref19) {
    var catalogId = _ref19.catalogId,
        created = _ref19.created,
        lotNumber = _ref19.lotNumber;
    return {
        payload: { catalogId: catalogId, created: created, lotNumber: lotNumber },
        type: LOT_SKIPPED
    };
};

var missive = function missive(_ref20) {
    var catalogId = _ref20.catalogId,
        created = _ref20.created,
        missiveText = _ref20.missiveText;
    return {
        payload: { catalogId: catalogId, created: created, missiveText: missiveText },
        type: MISSIVE
    };
};

var networkDisconnected = function networkDisconnected(_ref21) {
    var catalogId = _ref21.catalogId;
    return { payload: { catalogId: catalogId }, type: NETWORK_DISCONNECTED };
};
var networkReconnected = function networkReconnected(_ref22) {
    var catalogId = _ref22.catalogId;
    return { payload: { catalogId: catalogId }, type: NETWORK_RECONNECTED };
};

var nextLotOpened = function nextLotOpened(_ref23) {
    var amount = _ref23.amount,
        catalogId = _ref23.catalogId,
        created = _ref23.created,
        currency = _ref23.currency,
        itemId = _ref23.itemId;
    return {
        payload: { amount: amount, catalogId: catalogId, created: created, currency: currency, itemId: itemId },
        type: NEXT_LOT_OPENED
    };
};

var nextLotLoaded = function nextLotLoaded(_ref24) {
    var askPrice = _ref24.askPrice,
        catalogId = _ref24.catalogId,
        created = _ref24.created,
        currency = _ref24.currency,
        description = _ref24.description,
        highEstimate = _ref24.highEstimate,
        index = _ref24.index,
        itemId = _ref24.itemId,
        itemIndex = _ref24.itemIndex,
        lotNumber = _ref24.lotNumber,
        lotTitle = _ref24.lotTitle,
        lowEstimate = _ref24.lowEstimate,
        status = _ref24.status;
    return {
        payload: {
            askPrice: askPrice,
            catalogId: catalogId,
            created: created,
            currency: currency,
            description: description,
            highEstimate: highEstimate,
            index: index,
            itemId: itemId,
            itemIndex: itemIndex,
            lotNumber: lotNumber,
            lotTitle: lotTitle,
            lowEstimate: lowEstimate,
            status: status
        },
        type: NEXT_LOT_LOADED
    };
};

var updateActiveBiddersPubnub = function updateActiveBiddersPubnub(_ref25) {
    var bidderCount = _ref25.bidderCount,
        catalogId = _ref25.catalogId;
    return {
        payload: { bidderCount: bidderCount, catalogId: catalogId },
        type: UPDATE_ACTIVE_BIDDERS_PUBNUB
    };
};

var updateActiveBiddersSfs = function updateActiveBiddersSfs(_ref26) {
    var bidderCount = _ref26.bidderCount,
        catalogId = _ref26.catalogId,
        created = _ref26.created,
        itemId = _ref26.itemId,
        itemIndex = _ref26.itemIndex;
    return {
        payload: { bidderCount: bidderCount, catalogId: catalogId, created: created, itemId: itemId, itemIndex: itemIndex },
        type: UPDATE_ACTIVE_BIDDERS_SFS
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/console.js
// module id = FSAu
// module chunks = 60